import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isEnabledForFrontierCopilotAudience } from "./isEnabledForFrontierCopilotAudience";

export function isFocusBlockDirectiveFreEnabled(mailboxInfo: MailboxInfo): boolean {
    return (isGlobalFeatureEnabled("time-copilot-focus-block-directive-fre") ||
        isFocusBlockDirectiveFreFrontierEnabled(mailboxInfo));
}

export function isFocusBlockDirectiveFreFrontierEnabled(mailboxInfo: MailboxInfo): boolean {
    return isEnabledForFrontierCopilotAudience(mailboxInfo, {
        publicFlight: "time-copilot-focus-block-directive-fre-frontier-public",
        privateTapFlight: "time-copilot-focus-block-directive-fre-frontier-private-tap",
        privateStagingFlight: "time-copilot-focus-block-directive-fre-frontier-private-staging",
        privateInfluencerFlight: "time-copilot-focus-block-directive-fre-frontier-private-influencer",
    });
}
